import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { scrollTo } from './misc';

gsap.registerPlugin(ScrollTrigger);

function bannerLaPasserelle() {
    const logoContainers = document.querySelectorAll('[data-name="logo-strokes"]');

    logoContainers.forEach((container) => {
        const logoStrokes = container.querySelectorAll('path:not(:first-child)');
        const sequence = [1, 0, 2, 3, 5, 4]; 
        const totalDuration = 1.5; 
        const staggerAmount = 0.2;
        
        // Immediately set clip-path to prevent flash
        logoStrokes.forEach((stroke) => {
            gsap.set(stroke, { 
                clipPath: "inset(0 100% 0 0)",
                opacity: 1
            });
        });
        
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: container,
                start: "bottom bottom+=100",
                //markers: true
            }
        });
    
        sequence.forEach((pathIndex, order) => {
            const stroke = logoStrokes[pathIndex];
            if (!stroke) return;
    
            const startDelay = order * staggerAmount;
            const individualDuration = totalDuration - startDelay;
    
            // Add to timeline
            tl.to(stroke, {
                clipPath: "inset(0 0% 0 0)",
                duration: individualDuration, 
                delay: startDelay,
                ease: "power2.inOut"
            }, 0);
        });
    });
}

function skipLinks(){
	const allSections = document.querySelectorAll('[data-block], [data-custom-section]');

	if (allSections.length === 0) return;

	const blockData = Array.from(allSections).map(block => ({
		id: block.id,
		title: block.dataset.blockTitle || block.getAttribute('data-block-title'),
	})).filter(item => item.title);

    const toggleBlocks = document.querySelectorAll('[data-name="template-skip-links"]');

	if (toggleBlocks.length === 0) return;

	// Populate each block
	toggleBlocks.forEach(block => {        
		const list = block.querySelector('ul');
		if (!list) return;

        list.innerHTML = ''; // Clear existing links

		// Hide block if no items
		if (blockData.length === 0) {
			block.classList.add('hidden');
			return;
		}

		// Create the navigation list dynamically
		blockData.forEach(item => {
			const li = document.createElement('li');
			li.classList.add('group');

			const link = document.createElement('a');
			link.href = `#${item.id}`;
			link.setAttribute('data-scroll', 'scroll-to');
			link.setAttribute('data-scroll-space', '100'); // Add 100px offset to avoid covering titles
			link.appendChild(document.createTextNode(item.title));
			li.appendChild(link);
			list.appendChild(li);
		});
	});
}

function skipLinksSticky(){    
    const nav = document.querySelector('[data-name="template-skip-links"]');
    const footer = document.querySelector('#site-footer');
    
    if (!nav || !footer || window.innerWidth <= 768) return;

    // Create an outer wrapper to maintain the space in the document flow (prevents layout jump)
    const spaceHolder = document.createElement('div');
    spaceHolder.className = 'page-nav-spaceholder w-full';
    
    // Create an inner wrapper that will be pinned by GSAP (prevents GSAP/AOS style conflicts)
    const pinTarget = document.createElement('div');
    pinTarget.className = 'page-nav-pintarget w-fit relative z-50 mx-auto';

    nav.parentNode.insertBefore(spaceHolder, nav);
    spaceHolder.appendChild(pinTarget);
    pinTarget.appendChild(nav);

    // Transfer vertical margins to spaceHolder to avoid fixed positioning offsets breaking the layout
    const marginClasses = Array.from(nav.classList).filter(c => 
        c.startsWith('mt-') || c.startsWith('mb-') || c.includes(':mt-') || c.includes(':mb-')
    );
    nav.classList.remove(...marginClasses);
    spaceHolder.classList.add(...marginClasses);

    // Remove relative/z-50 from nav since pinTarget handles it now
    nav.classList.remove('relative', 'z-50');

    // Maintain layout space so the page doesn't jump when the element is pinned out of normal flow
    gsap.set(spaceHolder, { minHeight: nav.offsetHeight });

    const headerOffset = window.innerWidth > 991 ? 30 : 10;

    ScrollTrigger.create({
        trigger: spaceHolder,
        start: `top top+=${headerOffset}`,
        endTrigger: footer,
        end: `top top-=${headerOffset}`,
        pin: pinTarget,
        pinSpacing: false,
        invalidateOnRefresh: true,
        onRefresh: () => {
            if (pinTarget.style.position !== 'fixed') {
                gsap.set(spaceHolder, { minHeight: nav.offsetHeight });
            }
        },
        onUpdate: (self) => {
            const footerRect = footer.getBoundingClientRect();
            const navRect = nav.getBoundingClientRect();
            
            // Hide navigation if it would overlap with the footer
            if (navRect.bottom >= footerRect.top - 20) {
                gsap.to(pinTarget, { autoAlpha: 0, duration: 0.2, overwrite: 'auto' });
            } else {
                gsap.to(pinTarget, { autoAlpha: 1, duration: 0.2, overwrite: 'auto' });
            }
        },
        onLeave: () => {
            gsap.set(pinTarget, { autoAlpha: 0 });
        },
        onEnterBack: () => {
            gsap.to(pinTarget, { autoAlpha: 1, duration: 0.2 });
        }
    });
}

function laPasserelle(lenis) {
    bannerLaPasserelle();
    skipLinks();
    skipLinksSticky();
    
    // Re-initialize scrollTo to handle newly created skip links
    if (lenis) {
        scrollTo(lenis);
    }
}

export { laPasserelle };
